import React from 'react';
import { ICastingRoleAttributes } from 'shared/interfaces/ICastingRole';
import { useStyles } from '../Role.styles';
import LocationAndDateItem from './LocationAndDateItem/LocationAndDateItem';

type Props = {
  data: ICastingRoleAttributes | undefined;
};

const LocationAndDates: React.FC<Props> = ({ data }) => {
  const classes = useStyles();

  return (
    <div className={classes.gridContainer} style={{ gap: 30 }}>
      <LocationAndDateItem key="audition" type="Audition" data={data && data.audition ? data.audition : null} />
      <LocationAndDateItem key="callback" type="Callback" data={data && data.callback ? data.callback : null} />
      <LocationAndDateItem key="fitting" type="Fitting" data={data && data.fitting ? data.fitting : null} />
      <LocationAndDateItem key="working" type="Working" data={data && data.working ? data.working : null} />
    </div>
  );
};

export default LocationAndDates;
